import { useState, useEffect } from 'react';
import { setNetworkErrorCallback } from '../services/llm/openrouter';

export function NetworkErrorToast() {
  const [error, setError] = useState<string | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setNetworkErrorCallback((err) => {
      setError(err);
      setVisible(true);
      // 5秒后自动隐藏
      setTimeout(() => setVisible(false), 5000);
    });

    return () => setNetworkErrorCallback(null);
  }, []);

  if (!visible || !error) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '16px',
        left: '16px',
        right: '16px',
        background: 'var(--accent-red)',
        border: '2px solid var(--border-color)',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        zIndex: 9999,
        color: '#000',
      }}
    >
      <span style={{ fontSize: '16px' }}>⚠️</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '13px', fontWeight: 600 }}>网络错误</div>
        <div style={{ fontSize: '12px', opacity: 0.8 }}>{error}</div>
      </div>
      <button
        onClick={() => setVisible(false)}
        style={{
          padding: '4px 8px',
          background: 'transparent',
          border: '1px solid #000',
          fontSize: '12px',
          cursor: 'pointer',
        }}
      >
        关闭
      </button>
    </div>
  );
}
